
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telegram",
      function () {
        return require("private-next-pages/telegram/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telegram"])
      });
    }
  